import { getText } from '../../TranslationService';
import { PrivacyFooter } from '../shared/PrivacyFooter';
import { ActionButtons } from '../shared/Buttons/ActionButtons';

const commonAnchorAttributes = {
  target: '_blank',
  rel: 'noopener noreferrer',
};

const PrivacyLink = () => (
  <a
    id="ccmgt_explicit_privacy_policy"
    href={getText(`privacy_policy_link_url`)}
    class="pl1 pr1"
    {...commonAnchorAttributes}
  >
    {getText(`privacy_policy_link_name`)}
  </a>
);

const ImpressumLink = () => {
  if (getText(`impressum_policy_link_enabled`) == 'N/A') return;

  return (
    <a
      id="ccmgt_explicit_impressum"
      href={getText(`impressum_policy_link_url`)}
      class="pl1 pr1 hide-by-default policy-link-enabled"
      {...commonAnchorAttributes}
    >
      {getText(`impressum_policy_link_name`)}
    </a>
  );
};

export const Footer = () => (
  <PrivacyFooter>
    <ActionButtons moreOptionsId="ccmgt_explicit_preferences" acceptId="ccmgt_explicit_accept" />

    <div class="policy-links">
      <div class="footer-note">{getText(`footer_note`)}</div>
      <PrivacyLink />
      <ImpressumLink />
    </div>
  </PrivacyFooter>
);
